import Vue from "vue";
import Router from "vue-router";
import teaRouters from "./router-tea"; // 教师路由
import stuRouters from "./router-stu"; // 学生路由
import screenRouters from "./router-screen"; // 老师专用大屏路由
import login from "@/views/login.vue";

Vue.use(Router);

let router = new Router({
  mode: "hash",
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: "/login",
      name: "login",
      component: login,
      display: false,
    },
    {
      path: "/parent",
      name: "parent",
      component: () => import('@/views/parent/parentEnd'),
      meta: { role: "家长" },
    },
    {
      path: "/orderList",
      name: "orderList",
      component: () => import('@/views/parent/orderList'),
      meta: { role: "家长" },
    },
    ...stuRouters,
    ...teaRouters,
    ...screenRouters
  ],
});

// 路由白名单
const whiteRouter = ["/login", "/"];

// 路由拦截器
router.beforeEach((to, from, next) => {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
  const userRole = userInfo.jsmc; // 获取用户角色

  // 检查是否是白名单路由
  if (whiteRouter.includes(to.path)) {
    next();
    return;
  }

  // 检查是否有用户信息或角色不匹配
  if (!userRole || (to.meta.role && to.meta.role !== userRole)) {
    next('/login');
    return;
  }
  next();
});

// 解决路由重复点击报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

router.afterEach((to, from, next) => { });

export default router;
